import { IApplicationState } from '../../types/redux';

export function getIsAuthenticated(state: IApplicationState) {
  const {
    user: { userId },
  } = state;

  return typeof userId === 'number';
}
